module.exports = __webpack_public_path__ + "static/media/falling_leaves.da412199.png";